export default __webpack_public_path__ + "static/media/README.fce9adac.md";